<span class="button" *ngIf="item" (click)="localService.showSummary(item.key,2)" [ngClass]="localService.getLanguageCode(item.v4)">
  {{item.v3}}
</span>
